import { render, staticRenderFns } from "./StatusDatatable.vue?vue&type=template&id=6fe04bae"
import script from "./StatusDatatable.vue?vue&type=script&lang=js"
export * from "./StatusDatatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports